var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#1BC17A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 18.8429V19.8395C30.6653 22.1757 29.9089 24.4488 28.5101 26.3198C27.1113 28.1909 25.1452 29.5597 22.905 30.2221C20.6647 30.8845 18.2704 30.8049 16.079 29.9953C13.8877 29.1857 12.0167 27.6895 10.7452 25.7297C9.47371 23.7699 8.86977 21.4516 9.02348 19.1205C9.17719 16.7895 10.0803 14.5706 11.5981 12.7947C13.116 11.0188 15.1672 9.7812 17.4459 9.26636C19.7246 8.75152 22.1086 8.98707 24.2425 9.93787M30.6667 11.1667L19.8333 22.0108L16.5833 18.7608",
    stroke: "#05BB6D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.211a445b3ff0b98effd0d80fdb32ecd5.svg";
export { ForwardRef as ReactComponent };